import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_LOGOUT } from "../../action-types/actions";
import axios from "axios";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const logout = createAsyncThunk(
  ACTIONS_LOGOUT.logout,
  async ({ access_token, refresh_token }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.logout}`,
        { refresh_token },
        //   {
        // 	headers: {
        // 	  Authorization: `Bearer ${access_token}`,
        // 	  'User-Refresh-Token': `${refresh_token}`,
        // 	},
        //   }
      );
      if (response.data.status_code === 200) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);
      }
      // console.log('response.data.status_code:', typeof response.data.status_code);
      // console.log('response:', response);
      return response.data;
    } catch (error) {
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message || i18n.t("toast.logoutFailedPleaseTryAgain"));
      throw error.response?.data || new Error(error.message);
    }
  },
);
